import { render, staticRenderFns } from "./TextCard.vue?vue&type=template&id=ebab86f2&scoped=true"
import script from "./TextCard.vue?vue&type=script&lang=js"
export * from "./TextCard.vue?vue&type=script&lang=js"
import style0 from "./TextCard.vue?vue&type=style&index=0&id=ebab86f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebab86f2",
  null
  
)

export default component.exports